import { ArrayParam, StringParam } from 'use-query-params';
import { filtersQueryParamsSchema } from 'utils/useEncodedFilters/constants';

export const manualSelectionFilters = [
  'caseIdsToInclude',
  'caseIdsToExclude',
  'slideIdsToInclude',
  'slideIdsToExclude',
] as const;

export const paginationAndSortingParams = ['page', 'pageSize', 'sortBy'] as const;

export const casesSchema = {
  ...filtersQueryParamsSchema,
  studyId: StringParam,
  caseIdsToExclude: ArrayParam,
  slideIdsToExclude: ArrayParam,
};

export const casesOptions = {
  arrayFormat: 'repeat',
};
